import PageLayout from '../../../../component/layouts/PageLayout';
import { Helmet } from 'react-helmet-async';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

const CompareWithCheck24View: FC = () => {
  const { type } = useParams<{ type: 'gas' | 'power' | 'dsl' }>();

  return (
    <PageLayout showStaticMenu showBackButton pageTitle={'Check 24 Vergleichsrechner'}>
      <Helmet>
        <script src={`https://files.check24.net/widgets/auto/215379/c24pp-${type}-iframe/${type}-iframe.js`} />
      </Helmet>
      <div style={{ width: '100%' }} id={`c24pp-${type}-iframe`} data-style={'Wohnsinn'} />
    </PageLayout>
  );
};

export default CompareWithCheck24View;
